import { useState } from 'react';

export const useCODThankYouForm = () => {
  const [openKnownUserDrawer, setOpenKnownUserDrawer] = useState(false);
  const [openUnknownUserDrawer, setOpenUnknownUserDrawer] = useState(false);
  const [openAdsConfigurationDrawer, setOpenAdsConfigurationDrawer] =
    useState(false);
  const [openAdsKnownUserDrawer, setOpenAdsKnownUserDrawer] = useState(false);
  const [openAdsUnknownUserDrawer, setOpenAdsUnknownUserDrawer] =
    useState(false);
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openImageSectionDrawer, setOpenImageSectionDrawer] = useState(false);
  const [openMessagingDrawer, setOpenMessagingDrawer] = useState(false);

  const onToggleKnownUserDrawer = () =>
    setOpenKnownUserDrawer(!openKnownUserDrawer);

  const onToggleUnknownUserDrawer = () =>
    setOpenUnknownUserDrawer(!openUnknownUserDrawer);

  const onToggleAdsConfigurationDrawer = () =>
    setOpenAdsConfigurationDrawer(!openAdsConfigurationDrawer);

  const onToggleAdsKnownUserDrawer = () => {
    onToggleAdsConfigurationDrawer();
    setOpenAdsKnownUserDrawer(!openAdsKnownUserDrawer);
  };

  const onToggleAdsUnknownUserDrawer = () => {
    onToggleAdsConfigurationDrawer();
    setOpenAdsUnknownUserDrawer(!openAdsUnknownUserDrawer);
  };

  const onToggleImageSectionDrawer = () =>
    setOpenImageSectionDrawer(!openImageSectionDrawer);

  const onToggleMessagingDrawer = () =>
    setOpenMessagingDrawer(!openMessagingDrawer);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  return {
    openKnownUserDrawer,
    openUnknownUserDrawer,
    openAdsConfigurationDrawer,
    openAdsKnownUserDrawer,
    openAdsUnknownUserDrawer,
    openBackgroundDrawer,
    openImageSectionDrawer,
    openMessagingDrawer,
    onToggleKnownUserDrawer,
    onToggleUnknownUserDrawer,
    onToggleAdsConfigurationDrawer,
    onToggleAdsKnownUserDrawer,
    onToggleAdsUnknownUserDrawer,
    onToggleImageSectionDrawer,
    onToggleMessagingDrawer,
    onToggleBackgroundDrawer,
  };
};
